// src/contexts/MessageNotificationContext.js
import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useEcho from '../hooks/echo'; 
import useEchoChannel from '../hooks/useEchoChannel'; // Your custom hook

const MessageNotificationContext = createContext();

export const useNotification = () => useContext(MessageNotificationContext);

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);
    const location = useLocation(); // Get current path globally
    const echo = useEcho(); // Access your Echo instance
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    const loggedInUserId = loggedInUser?.id;

    // Function to add a notification
    const addNotification = useCallback((message) => {
        setNotifications(prev => [...prev, { id: Date.now(), message, seen: false }]);
        // Optionally, show a toast/pop-up here
        console.log("Global Notification:", message);
        // You can use a library like react-toastify or implement a custom toast
        // Example: toast.info(`New message from ${message.senderName}: ${message.body}`);
    }, []);

    // Function to clear a notification (e.g., when user clicks it)
    const clearNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(notif => notif.id !== id));
    }, []);

    const handleGlobalNewMessage = useCallback((event) => {
        

        console.log("Global Echo: Message received!", event);

        const incomingConversationId = event.conversation_id;
        const incomingSenderName = event.sender_name; // Adjust according to your event structure
      
        const isCurrentlyInChat = location.pathname.includes(`/messages/${incomingConversationId}`);

        if (!isCurrentlyInChat) {
            const notificationMessage = `New message from ${incomingSenderName} : "${event.body}"`;

            addNotification({
                text: notificationMessage,
                conversationId: incomingConversationId,
                senderName: incomingSenderName,
                body: event.body // Pass full message for context
            });

            // Optional: Desktop Notification API
            if (Notification.permission === "granted") {
                new Notification(`New Message from ${incomingSenderName}`, {
                    body: event.body,
                    // icon: '/path/to/your/icon.png' // Optional: path to an icon
                });
            } else if (Notification.permission !== "denied") {
                Notification.requestPermission().then(permission => {
                    if (permission === "granted") {
                        new Notification(`New Message from ${incomingSenderName}`, {
                            body: event.body,
                            // icon: '/path/to/your/icon.png'
                        });
                    }
                });
            }
        }
    }, [location.pathname, addNotification]); // Add location.pathname to dependencies

    // Subscribe to the global user channel here
    useEchoChannel(
        echo,
        loggedInUserId ? `user.${loggedInUserId}` : null,
        'MessageSendNotification',
        handleGlobalNewMessage
    );

    // You might also want to show a UI for notifications somewhere
    return (
        <MessageNotificationContext.Provider value={{ notifications, addNotification, clearNotification /*, activeChatId, setActiveChatId */ }}>
            {children}
            
            {notifications.map(notif => (
                <div key={notif.id} className="fixed bottom-4 right-4 bg-blue-500 text-white p-3 rounded shadow-lg z-50">
                    {notif.message.text}
                    {/* Optionally, add a link to the chat */}
                    <Link to={`/dashboard/messages/${notif.message.conversationId}`} className="ml-2 text-white underline">View</Link>
                    <button onClick={() => clearNotification(notif.id)} className="ml-2 text-white font-bold">X</button>

                </div>
            ))}
        </MessageNotificationContext.Provider>
    );
};